// GENERATED FROM /Users/michael/agoric/dapp-card-store/api/deploy.js
export default {
  "INSTANCE_BOARD_ID": "1221243446",
  "INSTALLATION_BOARD_ID": "1107051844",
  "SELL_ITEMS_INSTALLATION_BOARD_ID": "177231517",
  "INVITE_BRAND_BOARD_ID": "500716545",
  "brandBoardIds": {
    "Card": "379944443",
    "Money": "1532665031"
  },
  "issuerBoardIds": {
    "Card": "1530295560",
    "Money": "1576549616"
  },
  "pricePerCard": 1000000,
  "BRIDGE_URL": "http://127.0.0.1:8000",
  "API_URL": "http://127.0.0.1:8000",
  "CONTRACT_NAME": "cardStore"
};
